import * as constants from '../constants/app';

const initialState = {
    error: null,
};

export function reducer(state = initialState, action) {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case constants.SET_ERROR:
            newState.error = action.error
            return newState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/app.js